import { io } from 'socket.io-client';

const getTillData = () => {
  try {
    const tillData = JSON.parse(localStorage.getItem('tillData'));
    if (!tillData || !tillData.tillAccess || !tillData.tillAccess.cwrTill || !tillData.tillAccess.csBunit) {
      throw new Error('Invalid tillData in localStorage');
    }
    return {
      tillId: tillData.tillAccess.cwrTill.till,
      storeId: tillData.tillAccess.csBunit.csBunitId
    };
  } catch (error) {
    console.error('Error retrieving tillData:', error.message);
    return { tillId: null, storeId: null };
  }
};

let socket = null;
const socketServerUrl = process.env.REACT_APP_SOCKET_SERVER_URL;

// Function to reinitialize or update socket with new tillId and storeId
const updateSocketAuth = (tillId, storeId) => {
  if (!socket) {
    console.error('Socket not initialized. Ensure socketServerUrl is defined.');
    return;
  }

  // Disconnect existing socket if connected
  if (socket.connected) {
    socket.disconnect();
    console.log('Disconnected existing socket');
  }

  // Update socket auth
  socket.auth = { tillId, storeId };

  // Reconnect socket
  socket.connect();
  console.log('Reconnecting socket with tillId:', tillId, 'storeId:', storeId);
};

if (socketServerUrl) {
  const { tillId, storeId } = getTillData();

  socket = io(socketServerUrl, {
    path: '/socket.io',
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    auth: {
      tillId,
      storeId
    }
  });

  socket.on('connect', () => {
    console.log(`Connected to WebSocket server as till ${socket.auth.tillId}, store ${socket.auth.storeId}`);
    if (socket.auth.tillId && socket.auth.storeId) {
      socket.emit('registerTill', { tillId: socket.auth.tillId, storeId: socket.auth.storeId });
    } else {
      console.error('Cannot register till: tillId or storeId is missing');
    }
  });

  socket.on('reconnect', (attempt) => {
    console.log(`Reconnected to WebSocket server after ${attempt} attempts`);
  });

  socket.on('reconnect_attempt', () => {
    console.log('Attempting to reconnect...');
  });

  socket.on('reconnect_error', (error) => {
    console.error('Reconnection error:', error.message);
  });

  socket.on('connect_error', (error) => {
    console.error('Connection error:', error.message);
  });

  socket.on('disconnect', (reason) => {
    console.log('Disconnected from server:', reason);
  });

  socket.on('order:new', (data) => {
    console.log('New Order:', data);
    socket.emit('ack', { orderId: data.orderId, event: 'order:new' });
  });

  socket.on('order:update', (data) => {
    console.log('Order Update:', data);
    socket.emit('ack', { orderId: data?.order_id, event: 'order:update' });
  });

  socket.on('delivery:update', (data) => {
    console.log('Delivery Update:', data);
    socket.emit('ack', { orderId: data.orderId, event: 'delivery:update' });
  });

  socket.on('menu:update', (data) => {
    console.log('Menu Update:', data);
    socket.emit('ack', { menuId: data.menuId, event: 'menu:update' });
  });

  socket.on('menu:toggle', (data) => {
    console.log('Menu Toggle:', data);
    socket.emit('ack', { menuId: data.menuId, event: 'menu:toggle' });
  });

  socket.on('store:update', (data) => {
    console.log('Store Update:', data);
    socket.emit('ack', { storeId: data.storeId || socket.auth.storeId, event: 'store:update' });
  });

  socket.on('store:status', (data) => {
    console.log('Store Status:', data);
    socket.emit('ack', { storeId: data.storeId || socket.auth.storeId, event: 'store:status' });
  });

  socket.on('error', (error) => {
    console.error('Server error:', error);
  });
} else {
  console.warn('Socket.IO URL not defined in environment variables. Skipping WebSocket connection.');
}

export { socket, updateSocketAuth };